import React, { useEffect } from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import RecentTitlesPanel from "../RecentTitlesPanel";

const BACKDROP_CLASS = "fixed inset-0 z-40 bg-black/20";
const CLOSE_BUTTON_CLASS =
  "flex h-9 w-9 items-center justify-center rounded-md text-primary hover:bg-surface-muted focus:outline-none focus:ring-2 focus:ring-primary";
const DRAWER_CLASS =
  "fixed right-0 top-0 z-50 h-full w-full max-w-[360px] border-l border-border bg-surface p-4 shadow-surface";

const DrawerHeader = ({ onClose }) => (
  <div className="mb-4 flex items-center justify-between">
    <h2 className="font-montserrat text-lg font-semibold text-text">
      Recent Titles
    </h2>
    <button
      aria-label="Close recent titles"
      className={CLOSE_BUTTON_CLASS}
      onClick={onClose}
      type="button"
    >
      <CloseRoundedIcon fontSize="small" />
    </button>
  </div>
);

const useEscapeToClose = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);
};

const RecentTitlesDrawer = ({
  isOpen,
  onClose,
  onModeChange,
  onTitleSelect,
  selectedMode,
  titles,
}) => {
  useEscapeToClose({ isOpen, onClose });

  if (!isOpen) return null;

  return (
    <>
      <button
        aria-label="Close recent titles"
        className={BACKDROP_CLASS}
        onClick={onClose}
        type="button"
      />
      <aside
        aria-label="Recent titles drawer"
        className={DRAWER_CLASS}
      >
        <DrawerHeader onClose={onClose} />
        <RecentTitlesPanel
          isHeadingVisible={false}
          onModeChange={onModeChange}
          onTitleSelect={onTitleSelect}
          selectedMode={selectedMode}
          titles={titles}
        />
      </aside>
    </>
  );
};

export default RecentTitlesDrawer;
